var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('d2-demo-article')],1)}
var staticRenderFns = []

export { render, staticRenderFns }